import { t } from "@/i18n-js/instance";
import { EntityResource } from "../EntityResource";
import type { EventOption } from "../types";
import { AnyCommentSelector } from "./shared/AnyCommentSelector";
import { AnyPostSelector } from "./shared/AnyPostSelector";
import { AnyPostSpecificSelector } from "./shared/AnyPostSpecificSelector";

const moderationGroup = t("settings.workflows.form.event_groups.moderation");

export const postLiked: Readonly<EventOption> = {
  label: t("settings.workflows.form.events.post_liked.title"),
  value: "post_liked",
  group: t("settings.workflows.form.event_groups.posts_and_comments"),
  description: t("settings.workflows.form.events.post_liked.description"),
  formComponent: AnyPostSpecificSelector,
  viewComponent: EntityResource,
  icon: "post",
};

export const postPublished: Readonly<EventOption> = {
  label: t("settings.workflows.form.events.post_published.title"),
  value: "post_published",
  group: t("settings.workflows.form.event_groups.posts_and_comments"),
  description: t("settings.workflows.form.events.post_published.description"),
  formComponent: AnyPostSelector,
  viewComponent: EntityResource,
  icon: "post",
};

export const postFlagged: Readonly<EventOption> = {
  label: t("settings.workflows.form.events.post_flagged.title"),
  value: "post_flagged",
  group: moderationGroup,
  description: t("settings.workflows.form.events.post_flagged.description"),
  formComponent: AnyPostSpecificSelector,
  viewComponent: EntityResource,
  icon: "post",
};

export const postApproved: Readonly<EventOption> = {
  label: t("settings.workflows.form.events.post_approved.title"),
  value: "post_approved",
  group: moderationGroup,
  description: t("settings.workflows.form.events.post_approved.description"),
  formComponent: AnyPostSpecificSelector,
  viewComponent: EntityResource,
  icon: "post",
};

export const postRejected: Readonly<EventOption> = {
  label: t("settings.workflows.form.events.post_rejected.title"),
  value: "post_rejected",
  group: moderationGroup,
  description: t("settings.workflows.form.events.post_rejected.description"),
  formComponent: AnyPostSpecificSelector,
  viewComponent: EntityResource,
  icon: "post",
};

export const commentCreatedOnPost: Readonly<EventOption> = {
  label: t("settings.workflows.form.events.post_comment_created.title"),
  value: "post_comment_created",
  group: t("settings.workflows.form.event_groups.posts_and_comments"),
  description: t(
    "settings.workflows.form.events.post_comment_created.description",
  ),
  formComponent: AnyCommentSelector,
  viewComponent: EntityResource,
  icon: "post",
};

export const commentFlagged: Readonly<EventOption> = {
  label: t("settings.workflows.form.events.post_comment_flagged.title"),
  value: "post_comment_flagged",
  group: moderationGroup,
  description: t(
    "settings.workflows.form.events.post_comment_flagged.description",
  ),
  formComponent: AnyCommentSelector,
  viewComponent: EntityResource,
  icon: "post",
};

export const commentApproved: Readonly<EventOption> = {
  label: t("settings.workflows.form.events.post_comment_approved.title"),
  value: "post_comment_approved",
  group: moderationGroup,
  description: t(
    "settings.workflows.form.events.post_comment_approved.description",
  ),
  formComponent: AnyCommentSelector,
  viewComponent: EntityResource,
  icon: "post",
};

export const commentRejected: Readonly<EventOption> = {
  label: t("settings.workflows.form.events.post_comment_rejected.title"),
  value: "post_comment_rejected",
  group: moderationGroup,
  description: t(
    "settings.workflows.form.events.post_comment_rejected.description",
  ),
  formComponent: AnyCommentSelector,
  viewComponent: EntityResource,
  icon: "post",
};
